module.exports = __webpack_public_path__ + "images/37b4854f04b323a578f879472851124b-IMG_6373.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/home/IMG_6373.jpg
// module id = ./src/assets/images/slides/home/IMG_6373.jpg
// module chunks = 0